// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-history-page {
  width: 100%;
  max-width: 1360px;
  margin: 0 auto;
  padding: 28px 32px 48px;
  color: var(--text-primary, #142624);
}

.invoice-history-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin: 18px 0 24px;
}

.invoice-history-eyebrow {
  display: block;
  margin-bottom: 6px;
  color: var(--interactive-default, #0f766e);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.invoice-history-page-header h1 {
  margin: 0;
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.invoice-history-page-header p {
  margin: 8px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
}

.invoice-history-document-chip {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 330px;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 12px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}

.invoice-history-document-chip > svg {
  width: 22px;
  height: 22px;
  color: var(--interactive-default, #0f766e);
}

.invoice-history-document-chip > div {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
}

.invoice-history-document-chip strong,
.invoice-history-document-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.invoice-history-document-chip strong {
  font-size: 14px;
}
.invoice-history-document-chip > div span {
  color: var(--text-secondary, #506360);
  font-size: 12px;
}

.invoice-history-status {
  max-width: 110px;
  padding: 5px 9px;
  border-radius: 999px;
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
  font-size: 12px;
  font-weight: 600;
}

.invoice-history-private-banner {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 10px;
  background: var(--surface-secondary, #f4f7f7);
}

.invoice-history-private-banner svg {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  color: var(--interactive-default, #0f766e);
}
.invoice-history-private-banner strong {
  display: block;
  font-size: 14px;
}
.invoice-history-private-banner p {
  margin: 4px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
}

.invoice-history-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 20px;
  align-items: start;
}

.invoice-history-feed-panel,
.invoice-history-note-panel {
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 14px;
  background: var(--surface-primary, #fff);
  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);
}

.invoice-history-feed-panel {
  overflow: hidden;
}

.invoice-history-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}

.invoice-history-tabs {
  display: flex;
  gap: 6px;
}
.invoice-history-tabs button {
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 500;
}
.invoice-history-tabs button span {
  margin-left: 4px;
  opacity: 0.7;
}
.invoice-history-tabs button.active {
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}

.invoice-history-search {
  display: flex;
  align-items: center;
  gap: 8px;
  width: min(260px, 42%);
  padding: 8px 10px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 9px;
}
.invoice-history-search svg {
  color: var(--text-tertiary, #6b7b78);
}
.invoice-history-search input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 13px;
}

.invoice-history-feed {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
}
.invoice-history-event {
  display: flex;
  gap: 14px;
  padding: 16px;
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: 10px;
}
.invoice-history-event.is-note {
  background: var(--surface-secondary, #f4f7f7);
}
.invoice-history-event-icon {
  display: grid;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 50%;
  background: var(--interactive-soft, #f0f8f7);
  color: var(--interactive-default, #0f766e);
}
.invoice-history-event-icon svg {
  width: 17px;
  height: 17px;
}
.invoice-history-event-body {
  min-width: 0;
  flex: 1 1;
}
.invoice-history-event-heading {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.invoice-history-event-heading strong {
  font-size: 14px;
}
.invoice-history-event-heading time {
  flex: 0 0 auto;
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.invoice-history-event-body > span {
  display: block;
  margin-top: 6px;
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.invoice-history-event-body p {
  margin: 7px 0 0;
  font-size: 14px;
  line-height: 1.55;
  overflow-wrap: anywhere;
}

.invoice-history-note-panel {
  position: sticky;
  top: 84px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
}
.invoice-history-note-panel h2 {
  margin: 0;
  font-size: 18px;
}
.invoice-history-note-panel > div:first-child p {
  margin: 6px 0 0;
  color: var(--text-secondary, #506360);
  font-size: 13px;
  line-height: 1.5;
}
.invoice-history-note-panel label {
  font-size: 14px;
  font-weight: 500;
}
.invoice-history-note-panel textarea {
  min-height: 150px;
  resize: vertical;
  padding: 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: 10px;
  outline: none;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 14px;
  line-height: 1.55;
}
.invoice-history-note-panel textarea:focus {
  border-color: var(--interactive-default, #0f766e);
  box-shadow: none;
}
.invoice-history-note-meta {
  display: flex;
  justify-content: space-between;
  color: var(--text-secondary, #506360);
  font-size: 12px;
}
.invoice-history-note-panel > button {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  gap: 6px;
  min-height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 10px;
  background: var(--interactive-default, #0f766e);
  color: #fff;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
}
.invoice-history-note-panel > button:disabled {
  background: var(--interactive-disabled, #cdd6d4);
  color: var(--on-interactive-disabled, #8a9896);
  cursor: not-allowed;
}

.invoice-history-empty {
  display: flex;
  min-height: 240px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary, #506360);
  text-align: center;
}
.invoice-history-empty svg {
  width: 28px;
  height: 28px;
  margin-bottom: 10px;
  color: var(--interactive-default, #0f766e);
}
.invoice-history-empty p {
  margin: 5px 0 0;
  font-size: 13px;
}

.invoice-history-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border-top: 1px solid var(--border-subtle, #dce3e2);
  color: var(--text-secondary, #506360);
  font-size: 13px;
}

.invoice-history-pagination > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.invoice-history-pagination button {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cdd6d4);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
  cursor: pointer;
  font: inherit;
  font-weight: 500;
}

.invoice-history-pagination button:focus-visible {
  outline: 2px solid var(--interactive-default, #0f766e);
  outline-offset: 2px;
}

.invoice-history-pagination button:disabled {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-disabled, #8a9896);
  cursor: not-allowed;
}

.invoice-history-shell.dark .invoice-history-feed-panel,
.invoice-history-shell.dark .invoice-history-note-panel,
.invoice-history-shell.dark .invoice-history-document-chip {
  background: var(--surface-primary, #191b1f);
  border-color: var(--border-subtle, #2c3036);
}
.invoice-history-shell.dark .invoice-history-private-banner,
.invoice-history-shell.dark .invoice-history-event.is-note {
  background: var(--surface-secondary, #23262b);
}
.invoice-history-shell.dark .invoice-history-event {
  border-color: var(--border-subtle, #2c3036);
}
.invoice-history-shell.dark .invoice-history-pagination button {
  background: var(--surface-primary, #191b1f);
}

@media (max-width: 980px) {
  .invoice-history-workspace {
    grid-template-columns: 1fr;
  }
  .invoice-history-note-panel {
    position: static;
  }
}

@media (max-width: 720px) {
  .invoice-history-page {
    padding: 20px 16px 36px;
  }
  .invoice-history-page-header {
    flex-direction: column;
  }
  .invoice-history-document-chip {
    width: 100%;
    min-width: 0;
  }
  .invoice-history-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .invoice-history-search {
    width: 100%;
  }
  .invoice-history-event-heading {
    flex-direction: column;
    gap: 4px;
  }
  .invoice-history-event-heading time {
    white-space: normal;
  }
  .invoice-history-pagination {
    align-items: stretch;
    flex-direction: column;
  }
  .invoice-history-pagination > div {
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/Invoices/invoiceHistory.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,4CAA4C;EAC5C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,+CAA+C;EAC/C,mBAAmB;EACnB,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,SAAO;AACT;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;AACA;EACE,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iDAAiD;EACjD,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,+CAA+C;EAC/C,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,qCAAqC;EACrC,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;EAC7C,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;;EAGE,2CAA2C;EAC3C,2CAA2C;AAC7C;AACA;;EAEE,6CAA6C;AAC/C;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".invoice-history-page {\n  width: 100%;\n  max-width: 1360px;\n  margin: 0 auto;\n  padding: 28px 32px 48px;\n  color: var(--text-primary, #142624);\n}\n\n.invoice-history-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin: 18px 0 24px;\n}\n\n.invoice-history-eyebrow {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--interactive-default, #0f766e);\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.invoice-history-page-header h1 {\n  margin: 0;\n  font-size: 30px;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n}\n\n.invoice-history-page-header p {\n  margin: 8px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n}\n\n.invoice-history-document-chip {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 330px;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 12px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n\n.invoice-history-document-chip > svg {\n  width: 22px;\n  height: 22px;\n  color: var(--interactive-default, #0f766e);\n}\n\n.invoice-history-document-chip > div {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n}\n\n.invoice-history-document-chip strong,\n.invoice-history-document-chip span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.invoice-history-document-chip strong {\n  font-size: 14px;\n}\n.invoice-history-document-chip > div span {\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n\n.invoice-history-status {\n  max-width: 110px;\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.invoice-history-private-banner {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 16px;\n  padding: 16px;\n  border-radius: 10px;\n  background: var(--surface-secondary, #f4f7f7);\n}\n\n.invoice-history-private-banner svg {\n  flex: 0 0 auto;\n  width: 20px;\n  height: 20px;\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-history-private-banner strong {\n  display: block;\n  font-size: 14px;\n}\n.invoice-history-private-banner p {\n  margin: 4px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n\n.invoice-history-workspace {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 20px;\n  align-items: start;\n}\n\n.invoice-history-feed-panel,\n.invoice-history-note-panel {\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 14px;\n  background: var(--surface-primary, #fff);\n  box-shadow: 0 1px 2px rgba(14, 26, 32, 0.06);\n}\n\n.invoice-history-feed-panel {\n  overflow: hidden;\n}\n\n.invoice-history-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n\n.invoice-history-tabs {\n  display: flex;\n  gap: 6px;\n}\n.invoice-history-tabs button {\n  padding: 8px 10px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n}\n.invoice-history-tabs button span {\n  margin-left: 4px;\n  opacity: 0.7;\n}\n.invoice-history-tabs button.active {\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n\n.invoice-history-search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: min(260px, 42%);\n  padding: 8px 10px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 9px;\n}\n.invoice-history-search svg {\n  color: var(--text-tertiary, #6b7b78);\n}\n.invoice-history-search input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-size: 13px;\n}\n\n.invoice-history-feed {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 16px;\n}\n.invoice-history-event {\n  display: flex;\n  gap: 14px;\n  padding: 16px;\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: 10px;\n}\n.invoice-history-event.is-note {\n  background: var(--surface-secondary, #f4f7f7);\n}\n.invoice-history-event-icon {\n  display: grid;\n  flex: 0 0 34px;\n  width: 34px;\n  height: 34px;\n  place-items: center;\n  border-radius: 50%;\n  background: var(--interactive-soft, #f0f8f7);\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-history-event-icon svg {\n  width: 17px;\n  height: 17px;\n}\n.invoice-history-event-body {\n  min-width: 0;\n  flex: 1;\n}\n.invoice-history-event-heading {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n.invoice-history-event-heading strong {\n  font-size: 14px;\n}\n.invoice-history-event-heading time {\n  flex: 0 0 auto;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.invoice-history-event-body > span {\n  display: block;\n  margin-top: 6px;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.invoice-history-event-body p {\n  margin: 7px 0 0;\n  font-size: 14px;\n  line-height: 1.55;\n  overflow-wrap: anywhere;\n}\n\n.invoice-history-note-panel {\n  position: sticky;\n  top: 84px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n}\n.invoice-history-note-panel h2 {\n  margin: 0;\n  font-size: 18px;\n}\n.invoice-history-note-panel > div:first-child p {\n  margin: 6px 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.invoice-history-note-panel label {\n  font-size: 14px;\n  font-weight: 500;\n}\n.invoice-history-note-panel textarea {\n  min-height: 150px;\n  resize: vertical;\n  padding: 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: 10px;\n  outline: none;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-size: 14px;\n  line-height: 1.55;\n}\n.invoice-history-note-panel textarea:focus {\n  border-color: var(--interactive-default, #0f766e);\n  box-shadow: none;\n}\n.invoice-history-note-meta {\n  display: flex;\n  justify-content: space-between;\n  color: var(--text-secondary, #506360);\n  font-size: 12px;\n}\n.invoice-history-note-panel > button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-end;\n  gap: 6px;\n  min-height: 40px;\n  padding: 0 14px;\n  border: 0;\n  border-radius: 10px;\n  background: var(--interactive-default, #0f766e);\n  color: #fff;\n  cursor: pointer;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n}\n.invoice-history-note-panel > button:disabled {\n  background: var(--interactive-disabled, #cdd6d4);\n  color: var(--on-interactive-disabled, #8a9896);\n  cursor: not-allowed;\n}\n\n.invoice-history-empty {\n  display: flex;\n  min-height: 240px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-secondary, #506360);\n  text-align: center;\n}\n.invoice-history-empty svg {\n  width: 28px;\n  height: 28px;\n  margin-bottom: 10px;\n  color: var(--interactive-default, #0f766e);\n}\n.invoice-history-empty p {\n  margin: 5px 0 0;\n  font-size: 13px;\n}\n\n.invoice-history-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 16px;\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n  color: var(--text-secondary, #506360);\n  font-size: 13px;\n}\n\n.invoice-history-pagination > div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.invoice-history-pagination button {\n  min-height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cdd6d4);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n  cursor: pointer;\n  font: inherit;\n  font-weight: 500;\n}\n\n.invoice-history-pagination button:focus-visible {\n  outline: 2px solid var(--interactive-default, #0f766e);\n  outline-offset: 2px;\n}\n\n.invoice-history-pagination button:disabled {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-disabled, #8a9896);\n  cursor: not-allowed;\n}\n\n.invoice-history-shell.dark .invoice-history-feed-panel,\n.invoice-history-shell.dark .invoice-history-note-panel,\n.invoice-history-shell.dark .invoice-history-document-chip {\n  background: var(--surface-primary, #191b1f);\n  border-color: var(--border-subtle, #2c3036);\n}\n.invoice-history-shell.dark .invoice-history-private-banner,\n.invoice-history-shell.dark .invoice-history-event.is-note {\n  background: var(--surface-secondary, #23262b);\n}\n.invoice-history-shell.dark .invoice-history-event {\n  border-color: var(--border-subtle, #2c3036);\n}\n.invoice-history-shell.dark .invoice-history-pagination button {\n  background: var(--surface-primary, #191b1f);\n}\n\n@media (max-width: 980px) {\n  .invoice-history-workspace {\n    grid-template-columns: 1fr;\n  }\n  .invoice-history-note-panel {\n    position: static;\n  }\n}\n\n@media (max-width: 720px) {\n  .invoice-history-page {\n    padding: 20px 16px 36px;\n  }\n  .invoice-history-page-header {\n    flex-direction: column;\n  }\n  .invoice-history-document-chip {\n    width: 100%;\n    min-width: 0;\n  }\n  .invoice-history-toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .invoice-history-search {\n    width: 100%;\n  }\n  .invoice-history-event-heading {\n    flex-direction: column;\n    gap: 4px;\n  }\n  .invoice-history-event-heading time {\n    white-space: normal;\n  }\n  .invoice-history-pagination {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .invoice-history-pagination > div {\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
